/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { DataQuery } from '@typescript-kit/data';
import { HttpService } from '@angular-kit/core';

import { Company, CompanyData, RegisterCompanyDto, SubscriptionData, SubscriptionModel } from '@teamworks/global';

@Injectable()
export class CompanyService {

  constructor(private httpService: HttpService) {
  }

  async loadCompany(dataQuery?: DataQuery): Promise<Company> {
    return this.httpService.get(`api/base-data/company`, { 'data-query': dataQuery })
      .then((loadedData: CompanyData) => loadedData && new Company(loadedData));
  }

  async loadActiveSubscriptionList(dataQuery?: DataQuery): Promise<SubscriptionModel[]> {
    return this.httpService.get(`api/base-data/company/active-subscription-list`, { 'data-query': dataQuery })
      .then((loadedData: SubscriptionData[]) => loadedData?.map((s) => new SubscriptionModel(s)));
  }

  async registerCompany(registerData: RegisterCompanyDto): Promise<void> {
    return this.httpService.post(`api/register/new-company`, registerData);
  }

  async saveCompany(company: Company): Promise<Company> {
    return this.httpService.post(`api/base-data/company`, company);
  }

  async setSubscriptionState(isActive: boolean): Promise<SubscriptionModel[]> {
    return this.httpService.post(`api/base-data/company/subscription-state`, { isActive })
      .then((loadedData: SubscriptionData[]) => loadedData?.map((s) => new SubscriptionModel(s)));
  }

  async deleteCompany(): Promise<void> {
    return this.httpService.delete(`api/base-data/company`);
  }
}
